import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Lock, CheckCircle2, ArrowLeft } from "lucide-react";
import PasswordStrength from "@/components/travel/PasswordStrength";

export default function ResetPassword() {
  const [sp] = useSearchParams();
  const nav = useNavigate();
  const token = sp.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) { toast.error("6 caractères minimum"); return; }
    if (password !== confirm) { toast.error("Les mots de passe ne correspondent pas"); return; }
    setLoading(true);
    try {
      const r = await api.post("/auth/reset-password", { token, new_password: password });
      localStorage.setItem("tb_token", r.data.token);
      setDone(true);
      toast.success("Mot de passe mis à jour");
      setTimeout(() => { window.location.href = "/dashboard"; }, 1500);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Lien invalide ou expiré");
    } finally { setLoading(false); }
  };

  if (!token) {
    return (
      <div className="max-w-md mx-auto px-4 py-16">
        <div className="glass-strong rounded-2xl p-6 text-center">
          <p className="text-slate-300">Lien de réinitialisation invalide.</p>
          <Link to="/forgot-password" className="mt-4 inline-block btn-coral px-4 py-2 rounded-lg text-sm">Demander un nouveau lien</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-md mx-auto px-4 py-16">
      <div className="glass-strong rounded-2xl p-6">
        {done ? (
          <div className="text-center">
            <CheckCircle2 className="mx-auto text-emerald-400 mb-3" size={40}/>
            <h1 className="font-display text-xl font-bold">Mot de passe modifié</h1>
            <p className="text-sm text-slate-400 mt-1">Redirection…</p>
          </div>
        ) : (
          <>
            <h1 className="font-display text-2xl font-bold mb-1">Nouveau mot de passe</h1>
            <p className="text-sm text-slate-400 mb-6">Choisissez un mot de passe fort (6 caractères min.).</p>
            <form onSubmit={submit} className="space-y-3">
              <div className="flex items-center gap-2 px-3 py-2 rounded-lg bg-slate-900/60 border border-slate-700/60 focus-within:border-[#FF6B6B]">
                <Lock size={16} className="text-slate-400"/>
                <input data-testid="rp-password" type="password" required minLength={6} value={password} onChange={(e)=>setPassword(e.target.value)} placeholder="Nouveau mot de passe" className="bg-transparent flex-1 outline-none text-sm"/>
              </div>
              <PasswordStrength value={password} />
              <div className="flex items-center gap-2 px-3 py-2 rounded-lg bg-slate-900/60 border border-slate-700/60 focus-within:border-[#FF6B6B]">
                <Lock size={16} className="text-slate-400"/>
                <input data-testid="rp-confirm" type="password" required minLength={6} value={confirm} onChange={(e)=>setConfirm(e.target.value)} placeholder="Confirmer" className="bg-transparent flex-1 outline-none text-sm"/>
              </div>
              <button data-testid="rp-submit" disabled={loading} className="w-full btn-coral py-2.5 rounded-lg text-sm">{loading ? "…" : "Mettre à jour"}</button>
              <Link to="/login" className="inline-flex items-center gap-1 text-xs text-slate-400 hover:text-white mt-2"><ArrowLeft size={12}/> Retour à la connexion</Link>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
